import { __awaiter } from "tslib";
/**
 * 用户信息
 * 包括用户信息，用户权限信息。
 */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { notification } from 'antd';
import { token, loginUrl } from '@/shared/token';
export default createStore({
    state: {
        showEditMsg: false,
        showEditPwd: false,
        user: {
            userId: '',
            loginName: '未获取到登录名',
            phone: '',
            role: '',
            realName: '',
            roleId: '',
            tenantCode: '',
        },
    },
    effects: {
        // desc 获取用户信息
        getUserInfo(params, store) {
            return __awaiter(this, void 0, void 0, function* () {
                yield API.user.getAccount({}).then((res) => {
                    console.log(res);
                    this.SET_STATE({
                        user: {
                            userId: res.userId,
                            loginName: res.loginName,
                            phone: res.phone,
                            role: res.role,
                            realName: res.name,
                            roleId: res.roleId,
                            tenantCode: res.tenantCode,
                        },
                        resources: res.resources,
                        menus: res.menus,
                    });
                });
            });
        },
        // desc 修改用户密码
        editPwd(userPwd, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log('editPwd', userPwd);
                API.user.changePassword({
                    id: state.user.userId,
                    newPassword: userPwd,
                }).then(() => {
                    notification.success({
                        message: '密码修改成功',
                    });
                    this.SET_ShowEditPwd(false);
                    this.logout({});
                });
            });
        },
        // desc 修改用户信息
        editMsg(userMsg, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log(userMsg);
                API.user.editAccount({
                    id: state.user.userId,
                    loginName: state.user.loginName,
                    role: state.user.role,
                    contactPhone: userMsg.phone,
                    name: userMsg.realName,
                }).then(() => {
                    notification.success({
                        message: '账号信息修改成功',
                    });
                    this.SET_ShowEditMsg(false);
                    this.logout({});
                });
            });
        },
        logout(params, { state }) {
            API.user.logout({
                token,
            }).then(() => {
                window.location.replace(loginUrl);
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SET_ShowEditMsg(state, showState) {
            state.showEditMsg = showState;
        },
        SET_ShowEditPwd(state, showState) {
            state.showEditPwd = !state.showEditPwd;
        },
    },
});
